import {
    COUPON_LIST_GET_REQUEST,
    COUPON_OPEN_DRAWER,
    COUPON_DRAWER_LOADED,
    TRACK_PRINT_BAR_CODE_EVENT,
    TRACK_OPEN_COUPON_DRAWER_EVENT,
    TRACK_COUPON_SEE_DETAIL_EVENT,
} from '../actionTypes/CouponListActionTypes';

const getCouponListAction = () => ({
    type: COUPON_LIST_GET_REQUEST,
});

const openCouponDrawer = () => ({
    type: COUPON_OPEN_DRAWER,
});

const afterCouponDrawerLoad = () => ({
    type: COUPON_DRAWER_LOADED,
});

const trackPrintBarCode = () => ({
    type: TRACK_PRINT_BAR_CODE_EVENT,
});

const trackOpenCouponDrawer = () => ({
    type: TRACK_OPEN_COUPON_DRAWER_EVENT,
});

const trackCouponSeeDetail = () => ({
    type: TRACK_COUPON_SEE_DETAIL_EVENT,
});

export default {
    openCouponDrawer,
    afterCouponDrawerLoad,
    getCouponListAction,
    trackPrintBarCode,
    trackOpenCouponDrawer,
    trackCouponSeeDetail,
};
